// libs
import get from 'lodash/get';
import isEmpty from 'lodash/isEmpty';

// apis
import { getMenuContent } from 'shared/api/mega-menu';
import { getOfferText } from 'shared/api/offer';
import { getUPSOrderCount } from 'shared/api/UPSOrderCount';

// Helpers
// @ts-ignore as it was not able to find the type definition for logger
import logger from 'shared/logger';
import MemoizeAPIWithTTL from 'shared/helpers/memoizeAPIWithTTL';

// constants
import { API_CACHE_TTL } from 'shared/constants';

// redux store
import { ActionTypes } from './actions';

export { fetchUser } from './fetchUser';

const getMemoizedMenuData = (storeId: string) =>
  MemoizeAPIWithTTL({
    APIFunction: () => getMenuContent(storeId),
    ttl: API_CACHE_TTL,
    cacheHash: `MEGA_MENU_${storeId}`,
  });
const memoFetchOffer = MemoizeAPIWithTTL({
  APIFunction: getOfferText,
  ttl: API_CACHE_TTL,
  cacheHash: 'OFFER_TEXT',
});

export const fetchMenuDataV2 = (storeId = '') => {
  return (dispatch: any) => {
    dispatch({ type: ActionTypes.FETCH_MENU_PROGRESS });
    return getMemoizedMenuData(storeId)()
      .then((data) => {
        if (isEmpty(data)) {
          //@ts-ignore -- logger.error type mismatch with plain object
          logger.error({ ERROR: 'MANDATORY_RESPONSE_EMPTY', METHOD_NAME: 'getMenuContent' });
        }

        dispatch({
          type: ActionTypes.FETCH_MENU_SUCCESS,
          payload: data,
        });
      })
      .catch(() => {
        dispatch({ type: ActionTypes.FETCH_MENU_FAILED });
      });
  };
};

export const fetchOffer = (): any => {
  return (dispatch: any) => {
    dispatch({ type: ActionTypes.FETCH_HEADER_OFFER });
    return memoFetchOffer()
      .then((data) => {
        dispatch({
          type: ActionTypes.SET_HEADER_OFFER,
          payload: get(data, 'response.header_top.0', {}),
        });
      })
      .catch(() => {
        dispatch({ type: ActionTypes.FETCH_HEADER_OFFER_FAILED });
      });
  };
};

export const resolveMenuAPI = (): any => {
  return (dispatch: any) => {
    dispatch({
      type: ActionTypes.FETCH_MENU_SUCCESS,
      payload: [],
    });
  };
};

export const fetchUPSData = () => {
  return (dispatch: any) => {
    dispatch({ type: ActionTypes.FETCH_UPS_DATA_PROGRESS });
    return getUPSOrderCount()
      .then((data) => {
        const { result } = data;
        const installOfferCount = get(result, 'install_offer.count', {});

        dispatch({
          type: ActionTypes.SET_UPS_ORDER_COUNT,
          payload: installOfferCount,
        });

        return installOfferCount;
      })
      .catch((err) => {
        dispatch({
          type: ActionTypes.SET_UPS_ERROR,
          payload: `UPS_API_FAILURE: ${err}`,
        });

        return {};
      });
  };
};
